import React from 'react'

import { useStoreActions, useStoreState } from 'store'
import CurrencyInput from 'components/shared/CurrencyInput'

export default function PropertyValue() {
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updateDimensions } = useStoreActions(actions => actions.dimensions)
  const { propertyValue } = useStoreState(state => state.dimensions.dimensions.refinance)
  const dimensionsValidation = useStoreState(state => state.dimensions.dimensionsValidation)

  const handleChange = (value: number) => {
    updateDimensions({ refinance: { propertyValue: value } })
    onInputTracking({ name: 'propertyvalue', type: 'PROPERTYVALUE', label: 'property value', value })
  }

  return (
    <>
      <label className="FormLabel right-addon" htmlFor="propertyValue">
        Property value
      </label>
      <CurrencyInput
        id="propertyValue"
        testid="propertyValue"
        value={propertyValue}
        update={handleChange}
        invalid={
          dimensionsValidation.refinance.propertyValue.invalid || dimensionsValidation.refinance.minLtvRatio.invalid
        }
        errorMsg={
          dimensionsValidation.refinance.propertyValue.invalid
            ? dimensionsValidation.refinance.propertyValue.errorMsg
            : dimensionsValidation.refinance.minLtvRatio.errorMsg
        }
      />
    </>
  )
}
